module.exports = __webpack_public_path__ + "media/audio67.86435651.mp3";